/* istanbul ignore file */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import HorizontalCarousel from 'yoda-site-components/lib/components/Carousel/HorizontalCarousel';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import UrgencyMessagingConnected from '../../UrgencyMessaging/UrgencyMessaging';
import InnerImageZoom from '../../InlineZoomViewer/InnerImageZoom';
import styles from './SlickCarouselSmall.css';

const cx = classNames.bind(styles);

export default class SlickCarouselSmall extends Component {
    /**
     * Supported React properties
     * @type {Object}
     */

    static propTypes = {
        /**
         * Required field to pass data array to create carousel slides.
         */
        carouselData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

        /**
         * Renderer method that returns React component or any other HTML
         */
        carouselItemRenderer: PropTypes.func,

        /**
         * Minimum displace ment required in pixels to trigger the touch event actions.
         */
        // minimumSliderTouchThreshold: PropTypes.number,

        /**
         * Unique name for referencing dom element in automation testing
         * @type {String}
         */
        automationId: PropTypes.string,

        /**
         * Callback function when slide occurs
         * @type {Function}
         */
        slideCallback: PropTypes.func,

        /**

         /**
         * themeConfig will help in applying a different theme
         * i.e, User can override the default theme by passing
         * themeConfig as props
         * @type {boolean}
         */
        themeConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        autoplay: PropTypes.bool,
        displayArrows: PropTypes.bool,
        rewindOnChange: PropTypes.bool,
        repeat: PropTypes.bool,
        center: PropTypes.bool,
        updateRender: PropTypes.bool,
        isBundle: PropTypes.bool,
        slideInitialized: PropTypes.bool,
        carouselBulletTheme: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        autoPlay: PropTypes.bool,
        isCarouselTabDisplay: PropTypes.bool,
        isPromoBanner: PropTypes.bool,
        isPDPImage: PropTypes.bool,
        isbotWrapperClass: PropTypes.string,
        carouselSlideDefault: PropTypes.bool,
        setActiveDefaultCarousel: PropTypes.func,
        enableMobileSwatchTap: PropTypes.bool,
        enableVideoPlacementChange: PropTypes.bool,
        sponsoredProduct: PropTypes.bool,
        OnClickBeacon: PropTypes.string,
        ppId: PropTypes.string,
        skuId: PropTypes.string,
        isMobilePDPImageZoomed: PropTypes.bool,
        urgencyMessagingEnabled: PropTypes.bool,
        enableZoomOnProductImage: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        carouselData: {},
        automationId: '',
        themeConfig: [],
        deviceType: {},
        repeat: true,
        rewindOnChange: false,
        autoplay: false,
        displayArrows: true,
        slideCallback: null,
        carouselItemRenderer: () => {},
        center: false,
        updateRender: false,
        isBundle: false,
        slideInitialized: false,
        carouselBulletTheme: {},
        autoPlay: false,
        isCarouselTabDisplay: false,
        isPromoBanner: false,
        isPDPImage: false,
        isbotWrapperClass: '',
        carouselSlideDefault: false,
        enableMobileSwatchTap: false,
        setActiveDefaultCarousel: () => {},
        enableVideoPlacementChange: false,
        sponsoredProduct: false,
        OnClickBeacon: '',
        ppId: '',
        skuId: '',
        isMobilePDPImageZoomed: false,
        urgencyMessagingEnabled: true,
    };

    /**
     * Gets the theme to use
     * @return {[Object]} [theming classes]
     */
    static getThemeConfig(themeConfig) {
        return {
            carouselSelected: styles.selected,
            carouselBullets: dt(['fill-gray-15']),
            bullet: styles.bullet,
            nextWrapper: styles.nextWrapper,
            previousWrapper: styles.previousWrapper,
            next: styles.next,
            previous: styles.previous,
            slideClass: styles.slide,
            activeSlideClass: dt(['fill-gray-70']),
            ...themeConfig,
        };
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.themeConfig = SlickCarouselSmall.getThemeConfig(props.themeConfig);
        this.state = {
            videoLblSelected: {
                carousalIndex: null,
                videoID: null,
                updateWidth: false,
            },
        };
    }
    // fix found at https://github.com/akiran/react-slick/issues/1240#issuecomment-396484553

    componentDidMount() {
        if (!__SERVER__ && this.props.slideInitialized) {
            window.addEventListener('resize', this.slidetoNext);
            window.addEventListener('scroll', this.slidetoNext);
        }
        try {
            if (this.reactSlickWrapper && this.reactSlickWrapper.current) {
                this.reactSlickWrapper.current.addEventListener('touchstart', this.touchStart);
                this.reactSlickWrapper.current.addEventListener('touchmove', this.preventTouch, {
                    passive: false,
                });
            }
        } catch (err) {
            /* istanbul ignore next */
            console.log(err);
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rewindOnChange, carouselData } = this.props;
        /* istanbul ignore else */
        if (rewindOnChange && nextProps.carouselData !== carouselData) {
            this.slide(0);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {
            videoLblSelected: { videoID, carousalIndex },
            updateWidth,
        } = this.state;
        const {
            videoLblSelected: { videoID: nextVideoID, carousalIndex: nextCarousalIndex },
        } = nextState;

        if (this.props.carouselData !== nextProps.carouselData) {
            return true;
        }

        /* istanbul ignore if */
        if (this.props.themeConfig !== nextProps.themeConfig) {
            this.themeConfig = SlickCarouselSmall.getThemeConfig(nextProps.themeConfig);
            return true;
        }

        /* istanbul ignore if */
        if (this.props.center !== nextProps.center) {
            return true;
        }

        if (this.props.updateRender !== nextProps.updateRender) {
            return true;
        }

        /* istanbul ignore if */
        if (videoID !== nextVideoID || carousalIndex !== nextCarousalIndex) {
            return true;
        }

        /* istanbul ignore if */
        if (updateWidth !== nextState.updateWidth) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        try {
            if (!__SERVER__) {
                window.removeEventListener('scroll', this.slidetoNext);
                window.removeEventListener('resize', this.slidetoNext);
            }
            /* istanbul ignore else */
            if (this.reactSlickWrapper && this.reactSlickWrapper.current) {
                this.reactSlickWrapper.current.removeEventListener('touchstart', this.touchStart);
                this.reactSlickWrapper.current.removeEventListener('touchmove', this.preventTouch, {
                    passive: false,
                });
            }
        } catch (err) {
            /* istanbul ignore next */
            console.log(err);
        }
    }

    /* istanbul ignore next */
    slidetoNext = () => {
        if (this.props.autoplay && !__SERVER__) {
            this.slideTime && clearTimeout(this.slideTime);
            this.slideTime = setTimeout(() => {
                if (window.pageYOffset < 100) {
                    this.slide(this.slideIndex + 1);
                }
            }, 3000);
        }
    };

    slideCallback = (id) => {
        const { isBundle } = this.props;
        let idx = id;
        /* istanbul ignore next */
        // eslint-disable-next-line no-restricted-globals
        idx = isNaN(idx) ? 1 : idx;
        this.slideIndex = idx;
        !isBundle && this.props.slideCallback && this.props.slideCallback(idx);
        const videoLblSelectedTmp = { ...this.state.videoLblSelected };
        const scrollElement = document.getElementById('videoLabels');
        /* istanbul ignore next */
        if (this.props.carouselData && this.props.carouselData?.[idx]?.id) {
            videoLblSelectedTmp.carousalIndex = idx;
            videoLblSelectedTmp.videoID = this.props.carouselData?.[idx]?.id;
            this.setState({ videoLblSelected: videoLblSelectedTmp });
        } else {
            videoLblSelectedTmp.carousalIndex = null;
            videoLblSelectedTmp.videoID = null;
            this.setState({ videoLblSelected: videoLblSelectedTmp });
        }
        /* istanbul ignore next */
        if (scrollElement && this.props.carouselData && this.props.carouselData?.[idx]?.isVideo) {
            const totalVideos = this.props.carouselData.filter((item) => item.isVideo);
            const selectedElement = document.getElementById(
                get(this.state.videoLblSelected, 'videoID', null)
            );
            idx > totalVideos.length / 2
                ? scrollElement.scrollTo(selectedElement?.getBoundingClientRect().left - 10, 0)
                : scrollElement.scrollTo(selectedElement?.getBoundingClientRect().left + 10, 0);
        }
    };

    /* istanbul ignore next */
    slide = (idx) => {
        let id = idx;
        // eslint-disable-next-line no-restricted-globals
        id = isNaN(id) ? 1 : id;
        this.reactSlick && this.reactSlick.slickGoTo(id);
    };

    setUpdateWidth = (data) => {
        this.setState({ updateWidth: data });
    };

    itemRenderer = (...args) =>
        this.themeConfig.slideClass ? (
            <div className={cx(this.themeConfig.slideClass)}>
                {this.props.carouselItemRenderer.apply(null, args)};
            </div>
        ) : (
            <> {this.props.carouselItemRenderer.apply(null, args)}</>
        );

    updateditemRenderer = (...args) => {
        const { deviceType, enableZoomOnProductImage } = this.props;
        const { innerHeight } = window;
        const { innerWidth } = window;
        const isLandscapeOrientation = innerWidth > innerHeight;
        const smallImageWidth = isLandscapeOrientation ? innerWidth : innerHeight;
        const data = args[0]; // Assuming the first argument is the current item in carouselData
        const src = data?.url;
        const zoomSrc = src?.replace(/=(350|550)/g, (match, p1) => `=${p1 * 2}`);
        // eslint-disable-next-line no-nested-ternary
        const imgsrc = this.state.updateWidth ? zoomSrc : src;
        const { isVideo } = data;
        return this.themeConfig.slideClass ? (
            !isVideo ? (
                <div className={cx(this.themeConfig.slideClass)}>
                    {/* Wrap the carousel item renderer output with InnerImageZoom */}
                    <InnerImageZoom
                        src={imgsrc}
                        deviceType={deviceType}
                        key={src}
                        zoomSrc={zoomSrc}
                        isLandscape={isLandscapeOrientation}
                        updateWidth={this.setUpdateWidth}
                        shouldLoadZoomImgOnLoad
                        enableZoomOnProductImage={enableZoomOnProductImage}
                    />
                </div>
            ) : (
                this.props.carouselItemRenderer.apply(null, args)
            )
        ) : (
            <>
                {/* Wrap the carousel item renderer output with InnerImageZoom */}
                <InnerImageZoom
                    src={imgsrc}
                    deviceType={deviceType}
                    key={src}
                    zoomSrc={zoomSrc}
                    isLandscape={isLandscapeOrientation}
                    updateWidth={this.setUpdateWidth}
                    shouldLoadZoomImgOnLoad
                    enableZoomOnProductImage={enableZoomOnProductImage}
                />
            </>
        );
    };

    /* istanbul ignore next */
    videoLabelClickHandler = (e) => {
        e && e.preventDefault && e.preventDefault();
        const targetID = get(e.currentTarget, 'id', null);
        let idx = 0;
        this.props.carouselData.forEach((item, index) => {
            if (item.id === targetID) {
                idx = index;
            }
        });
        this.slide(idx);
    };

    touchStart(e) {
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }

    preventTouch(e) {
        const minValue = 5; // threshold

        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;

        // Vertical scrolling does not work when you start swiping horizontally.
        if (Math.abs(this.clientX) > minValue) {
            e.preventDefault();
            e.returnValue = false;
            return false;
        }
        return true;
    }

    render() {
        const {
            carouselData,
            carouselBulletTheme,
            carouselSlideDefault,
            enableZoomOnProductImage,
            isBundle,
            isCarouselTabDisplay,
            isbotWrapperClass,
            enableVideoPlacementChange,
            isMobilePDPImageZoomed,
            urgencyMessagingEnabled,
            autoPlay,
            displayArrows,
            isPromoBanner,
            repeat,
            isPDPImage,
            setActiveDefaultCarousel,
            enableMobileSwatchTap,
            sponsoredProduct,
            OnClickBeacon,
            ppId,
            skuId,
        } = this.props;
        const {
            videoLblSelected: { videoID },
        } = this.state;

        const productVideoLabels = carouselData.map((item) =>
            item.isVideo ? (
                <div className={cx('videoLabelContainer')}>
                    <a
                        id={item.id}
                        href={item.url}
                        className={dt(['flex', 'items-center'])}
                        onClick={this.videoLabelClickHandler}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div
                            className={`${dt([
                                'w-6',
                                'h-6',
                                'rounded-half',
                                'mr-1',
                                'border',
                                'border-solid',
                                'border-gray-60',
                                'relative',
                            ])} ${cx('videoIcon')}`}
                        >
                            <span
                                className={`${dt([
                                    videoID === item.id && 'border-transparent',
                                    videoID === item.id && 'border-l-black',
                                ])} ${cx('playIcon')}`}
                            />
                        </div>
                        <div
                            className={`${dt([
                                videoID === item.id && 'font-open-sans',
                                videoID === item.id && 'font-bold',
                                videoID === item.id && 'text-black',
                            ])} ${cx('videoLabel', 'labelTxt')}`}
                        >
                            {
                                /* istanbul ignore next */
                                item.label ? item.label : 'Product Video'
                            }
                        </div>
                    </a>
                </div>
            ) : null
        );

        return (
            <>
                <section
                    className={cx(styles.carousel, { bundleImageContainer: isBundle })}
                    data-automation-id={this.props.automationId}
                    ref={(reactSlickWrapper) => {
                        this.reactSlickWrapper = reactSlickWrapper;
                    }}
                >
                    <div className={this.themeConfig.carouselBlock}>
                        <div
                            data-automation-id="main"
                            className={
                                (this.themeConfig.carouselContainer,
                                this.themeConfig.slickTrackClass)
                            }
                            ref={(reactSlickWrapper) => {
                                this.reactSlickWrapper = reactSlickWrapper;
                            }}
                        >
                            {carouselData.length > 1 ? (
                                <HorizontalCarousel
                                    isCarouselTabDisplay={isCarouselTabDisplay}
                                    className={this.themeConfig.carouselContainer}
                                    key={carouselData.length}
                                    ref={(reactSlick) => {
                                        this.reactSlick = reactSlick;
                                    }}
                                    direction="horizontal"
                                    carouselBulletTheme={carouselBulletTheme}
                                    autoPlay={autoPlay}
                                    arrows={displayArrows}
                                    carouselData={carouselData}
                                    isPromoBanner={isPromoBanner}
                                    infinite={repeat}
                                    slideCallback={this.slideCallback}
                                    isPDPImage={isPDPImage}
                                    carouselSlideDefault={carouselSlideDefault}
                                    setActiveDefaultCarousel={setActiveDefaultCarousel}
                                    enableMobileSwatchTap={enableMobileSwatchTap}
                                    enableVideoPlacementChange={enableVideoPlacementChange}
                                    sponsoredProduct={sponsoredProduct}
                                    OnClickBeacon={OnClickBeacon}
                                    enableZoomOnProductImage={enableZoomOnProductImage}
                                    ppId={ppId}
                                    skuId={skuId}
                                >
                                    {!__SERVER__ && carouselData.map(this.updateditemRenderer)}
                                </HorizontalCarousel>
                            ) : (
                                <div
                                    className={
                                        isCarouselTabDisplay
                                            ? dt([
                                                  'flex',
                                                  'border-b-2',
                                                  'border-light-white',
                                                  'border-solid',
                                              ])
                                            : cx('singleImageCarousel')
                                    }
                                >
                                    {!__SERVER__ &&
                                        this.props.carouselData.map(this.updateditemRenderer)}
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                <ErrorBoundary>
                    {urgencyMessagingEnabled ? (
                        <span
                            data-automation-id="urgency-icon"
                            className={`${cx('UrgencyMessaging')} ${dt([
                                'absolute',
                                '-translate-x-1/2',
                                'left-1/2',
                                'w-full',
                            ])}`}
                        >
                            <UrgencyMessagingConnected
                                isMobilePDPImageZoomed={isMobilePDPImageZoomed}
                            />
                        </span>
                    ) : null}
                </ErrorBoundary>
                {!enableVideoPlacementChange && (
                    <div
                        className={`${dt([
                            'whitespace-nowrap',
                            'overflow-x-auto',
                            'flex',
                            'flex-wrap',
                            'smOnly:px-6',
                        ])} ${cx('videoLabelsContainer', isbotWrapperClass)}`}
                        id="videoLabels"
                    >
                        {
                            /* istanbul ignore next */
                            isBundle ? null : productVideoLabels
                        }
                    </div>
                )}
            </>
        );
    }
}
